import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7rglxgdkwi: FaireBrandEntity = {
  token: "b_7rglxgdkwi",
  type: "brand",
  name: "Mountain Maiden Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/9bd8386c4d074a7c8ec29a7b6e658cb0cac1c62dc72dfa5e778ae7b0f037ed98.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1f66ad9ddc8c11fed949b5cb4951e988ceae5238cd9002dccda22134d645873b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9bd8386c4d074a7c8ec29a7b6e658cb0cac1c62dc72dfa5e778ae7b0f037ed98.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1f66ad9ddc8c11fed949b5cb4951e988ceae5238cd9002dccda22134d645873b.jpeg",
  location: "Deadwood, SD, USA",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "In the heart of the Black Hills, where the mountains stand as silent sentinels to centuries of creative and cultural traditions, Mountain Maiden Co. was born in 2019. Conceived from a deep-rooted love for the natural world and a profound awe for the majestic landscapes that envelope the artist, this brand emerged as a homage to the splendor of the American West.\n\nMountain Maiden Co. is more than a brand; it's a narrative etched in every piece—a story of reverence for the maidens in all of us, a celebration of botanical beauty, and an exploration of the timeless ties between myth, art, and the natural world. Each design is a testament to the harmonious blend of inspiration and tradition, making Mountain Maiden Co. not just another brand, but a journey through the rich landscapes of creativity and culture.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:31.805Z",
    importedBy: "entity-db-cli",
  },
};
